import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { OwlOptions } from "ngx-owl-carousel-o";
import { BaseService } from "../base.service";
import { environment } from "../../../environments/environment";
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { Title } from "@angular/platform-browser";
@Component({
  selector: "app-tv-shows",
  templateUrl: "./tv-shows.component.html",
  styleUrls: ["./tv-shows.component.css"],
})
export class TvShowsComponent implements OnInit {
  shimmerStatus = {
    category: true,
  };
  data: any;
  apiParam = { type: "", limit: 20, offset: 0, feature: false, banner: false };
  subcategory = [];
  investiLanguage: any;
  loadMore = false;
  initStatus: boolean;
  viewMore = true;
  show = true;
  homeData;
  @ViewChild("panel", { read: ElementRef }) public panel: ElementRef<any>;

  constructor(
    public service: BaseService,
    private router: Router,
    private route: ActivatedRoute,
    public translate: TranslateService,
    private titleService: Title
  ) {}

  ngOnInit(): void {
    window.scrollTo(0, 0);
    if (localStorage.getItem(environment.localStorageLangKey)) {
      this.investiLanguage = JSON.parse(
        localStorage.getItem(environment.localStorageLangKey)
      );
      this.translate.use(this.investiLanguage);
    }

    // this.translate.onLangChange.subscribe((e: any) => {
    //   this.titleService.setTitle(e.translations.PAGE_TITLE);
    // });
    this.initStatus = true;
    if (this.router.url) {
      let url = this.router.url.split("/");
      this.apiParam.type = url[1];
      this.service.playerReady = false;
      this.service.modelData = undefined;
    } else {
      this.service.playerReady = false;
      this.service.modelData = undefined;
    }
    this.getData("");
  }

  watching: OwlOptions = {
    loop: false,
    autoplay: false,
    mouseDrag: true,
    autoWidth: true,
    touchDrag: true,
    pullDrag: true,
    dots: false,
    navSpeed: 700,
    smartSpeed: 1,
    skip_validateItems: true,
    navText: ["", ""],
    responsive: {
      0: {
        items: 1.5,
      },
      380: {
        items: 1.5,
      },
      450: {
        items: 2.3,
      },
      650: {
        items: 3.2,
      },
      910: {
        items: 4.2,
      },
      1108: {
        items: 4.2,
      },
      1230: {
        items: 4.2,
      },
      1257: {
        items: 4.2,
      },
      1366: {
        items: 5.2,
      },
    },
    nav: true,
  };

  playOff() {
    this.service.modelData = undefined;
    this.service.playerReady = false;
  }

  getData(from) {
    const localdata = JSON.parse(
      localStorage.getItem(environment.pagesLocalStorageKey)
    );
    let index = -1;
    if (localdata) {
      index = localdata
        .map((el) => {
          return el.hasOwnProperty(this.apiParam.type);
        })
        .indexOf(true);
    }

    if (localdata && index != -1) {
      this.data = localdata[index][this.apiParam.type];
      this.homeData = localdata[index][this.apiParam.type];
      this.subcategory = localdata[index][this.apiParam.type].subcategory;
      this.shimmerStatus.category = false;
    } else {
      this.moreData(from);
    }
  }
  moreData(from) {
    if (this.initStatus) {
      let localdata = JSON.parse(
        localStorage.getItem(environment.pagesLocalStorageKey)
      );

      if (!localdata) {
        localdata = [];
      }
      const index = localdata.findIndex((values) => values[this.apiParam.type]);

      this.service.categoryData(this.apiParam).subscribe(
        (data: any) => {
          this.data = data;
          if (from === "") {
            this.subcategory = [];
          }
          if (this.data.subcategory.length > 0) {
            this.subcategory = this.subcategory.concat(this.data.subcategory);
            this.loadMore = false;
            this.show = true;
            this.shimmerStatus.category = false;
            if (index != -1) {
              localdata[index][this.apiParam.type].subcategory = localdata[
                index
              ][this.apiParam.type].subcategory.concat(this.data.subcategory);
            } else {
              localdata.push({ [this.apiParam.type]: this.data });
            }
            localStorage.setItem(
              environment.pagesLocalStorageKey,
              JSON.stringify(localdata)
            );
          } else {
            this.shimmerStatus.category = false;
            this.loadMore = false;
            this.show = false;
          }
        },
        (err) => {
          if (err) {
            setTimeout(() => {
              this.shimmerStatus.category = false;
              this.loadMore = false;
            }, 3000);
          }
        }
      );
    }
  }

  viewMoreData() {
    this.loadMore = true;
    this.show = false;
    if (this.data.subcategory.length > 0 && this.loadMore === true) {
      this.apiParam.offset = this.apiParam.limit + this.apiParam.offset;
      this.moreData("pagination");
    }
  }
}
